<template>
  <div class="m-5 xl:m-15 2xl:m-20">
    <!-- BEGIN Popup compare cartography -->
    <PopupCompareCarto
      :compare-carto="compareCarto"
      @close="closeCompare"
      @changeCompare="
        (index) => {
          changeCompare(index);
        }
      "
      :carto-to-compare="cartoToCompare"
      :history-to-display="historyToDisplay"
      :competences-cles="{}"
      :history-competences-cles="[]"
      :competences-informatique="{}"
      :history-competences-informatique="[]"
      :competences-linguistique="{}"
      :history-competences-linguistique="[]"
      :competences-socio-pro="{}"
      :history-competences-socio-pro="{}"
      :competences-pro="typeReferentiel === 'ROME' ? competencesSco : {}"
      :history-competences-pro="
        typeReferentiel === 'ROME' ? historyCompetencesSco : {}
      "
      :competences-sco="
        typeReferentiel === 'ref_formation' ? competencesSco : {}
      "
      :history-competences-sco="
        typeReferentiel === 'ref_formation' ? historyCompetencesSco : {}
      "
      v-if="compareCarto"
    />
    <!-- END Popup compare cartography -->

    <div
      v-if="
        Object.keys(competencesSco).length > 0 ||
        Object.keys(historyCompetencesSco).length > 0
      "
    >
      <h3 class="mb-10">Compétences professionnelles</h3>

      <!-- BEGIN list domaine -->
      <div class="flex justify-center">
        <div
          class="flex flex-row self-center relative justify-end items-center cursor-pointer my-8 w-max-content w-max"
          @click="displayFieldList"
          @click.stop
        >
          <div class="flex flex-row ml-auto items-end">
            <h3
              v-if="listCompetencesSco.length > 0"
              class="text-xl text-indigo-600"
            >
              {{ currentPoste }}
            </h3>
          </div>
          <div
            class="text-pink-600 max-h-8 mr-auto rounded-full relative inline-flex items-center p-2 order-2"
          >
            <icon
              v-if="listCompetencesSco.length > 0"
              class="h-4 w-4"
              name="chevron-down"
            />
          </div>
          <div
            class="fieldlist z-20 w-max-content w-max mt-2 absolute rounded-md bg-white flex transform translate-y-full self-end shadow-md shadow-gray-600 text-sm"
            v-click-outside="displayFieldList"
            v-if="showList"
          >
            <div class="mx-5 my-3">
              <div class="text-left">
                <div
                  class="first:pt-2 py-1"
                  v-for="(field, i) in listCompetencesSco.filter(
                    (c) =>
                      Object.keys(competencesSco).includes(c.name) ||
                      Object.keys(historyCompetencesSco).includes(c.name)
                  )"
                  :key="i"
                >
                  <p
                    class="text-gray-600 hover:text-gray-900"
                    @click="selectedPoste = field.name"
                  >
                    <span>{{ 'Formation ' + field.name.split('f')[1] }} </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END list domaine -->

      <div
        v-for="(sco, index) in listCompetencesSco"
        :key="index"
        class="my-10"
      >
        <div v-if="competencesSco[sco.name] || historyCompetencesSco[sco.name]">
          <!-- Case there is a current evaluation -->
          <div v-if="competencesSco[sco.name] && selectedPoste == sco.name">
            <div v-if="typeReferentiel === 'ref_formation'">
              <div
                v-for="(mod, indexModule) in competencesSco[sco.name]"
                :key="indexModule"
                class="mb-15"
              >
                <div v-if="!['name_job', 'labels'].includes(indexModule)">
                  <h5>{{ indexModule }}</h5>
                  <div class="xl:grid xl:grid-cols-2 xl:gap-x-5">
                    <div class="xl:col-span-1">
                      <bar
                        v-if="
                          Object.keys((mod || {}).module_competences || {})
                            .length > 0
                        "
                        :id-chart="
                          'compscoAutoToday' + indexModule + 'competences'
                        "
                        title="Compétences"
                        orientation="vertical"
                        thickness="10"
                        height="400"
                        width="400"
                        :stacked="false"
                        :labels="
                          competencesSco[sco.name].labels
                        "
                        :values="mod.module_competences"
                        :display-legend="true"
                      />
                    </div>
                    <div class="xl:col-span-1">
                      <bar
                        v-if="
                          Object.keys(
                            (mod || {}).module_competences_transversales || {}
                          ).length > 0
                        "
                        :id-chart="
                          'compscoAutoToday' +
                          indexModule +
                          'competences_transversales'
                        "
                        title="Compétences transversales"
                        orientation="vertical"
                        thickness="10"
                        height="400"
                        width="400"
                        :stacked="false"
                        :labels="
                          competencesSco[sco.name].labels
                        "
                        :values="mod.module_competences_transversales"
                        :display-legend="true"
                      />
                    </div>
                  </div>
                  <div
                    class="mt-8 w-full text-center flex justify-center"
                    v-if="
                      $can(
                        constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_COMPARE
                      )
                    "
                  >
                    <action-button
                      class="py-2"
                      border-color="transparent"
                      text-color="text-white"
                      bg-color="bg-pink-600"
                      libelle="Comparer"
                      :is-disabled="cantCompare(sco.name)"
                      :enable-action="canCompare(sco.name)"
                      @clickAction="
                        displayCompareCarto(
                          'compsco/' + sco.name + '/' + indexModule
                        )
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
            <div v-if="typeReferentiel === 'ROME'">
              <h3>Compétences de base</h3>
              <div>
                <div>
                  <pie
                    v-if="competencesSco[sco.name].datas.length > 0"
                    id-chart="romeCompetencesBasesSavoirFaire"
                    title="Savoir-faire"
                    :labels="competencesSco[sco.name].longLabels"
                    :values="[
                      competencesSco[sco.name].datas[0]['competences_bases'][
                        'savoir_faire'
                      ],
                      competencesSco[sco.name].datas[1]['competences_bases'][
                        'savoir_faire'
                      ],
                    ]"
                    :colors="competencesSco[sco.name].colors"
                    position-legend="bottom"
                    height="400"
                  />
                </div>
                <div
                  class="mt-5 w-full text-center flex justify-center"
                  v-if="
                    $can(constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_COMPARE)
                  "
                >
                  <action-button
                    class="py-2"
                    border-color="transparent"
                    text-color="text-white"
                    bg-color="bg-pink-600"
                    libelle="Comparer"
                    :is-disabled="cantCompare(sco.name)"
                    :enable-action="canCompare(sco.name)"
                    disabled-tooltip="Pour profiter de cette fonctionnalité, veuillez faire une deuxième évaluation pour les comparer."
                    @clickAction="
                      displayCompareCarto(
                        'compproRome/' +
                          sco.name +
                          '/competences_bases/savoir_faire'
                      )
                    "
                  />
                </div>
              </div>
              <div>
                <div>
                  <pie
                    v-if="competencesSco[sco.name].datas.length > 0"
                    id-chart="romeCompetencesBasesSavoirs"
                    title="Savoirs"
                    :labels="competencesSco[sco.name].longLabels"
                    :values="[
                      competencesSco[sco.name].datas[0]['competences_bases'][
                        'savoirs'
                      ],
                      competencesSco[sco.name].datas[1]['competences_bases'][
                        'savoirs'
                      ],
                    ]"
                    :colors="competencesSco[sco.name].colors"
                    position-legend="bottom"
                    height="400"
                  />
                </div>
                <div
                  class="mt-5 w-full text-center flex justify-center"
                  v-if="
                    $can(constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_COMPARE)
                  "
                >
                  <action-button
                    class="py-2"
                    border-color="transparent"
                    text-color="text-white"
                    bg-color="bg-pink-600"
                    libelle="Comparer"
                    :is-disabled="cantCompare(sco.name)"
                    :enable-action="canCompare(sco.name)"
                    disabled-tooltip="Pour profiter de cette fonctionnalité, veuillez faire une deuxième évaluation pour les comparer."
                    @clickAction="
                      displayCompareCarto(
                        'compproRome/' + sco.name + '/competences_bases/savoirs'
                      )
                    "
                  />
                </div>
              </div>

              <h3>Compétences spécifiques</h3>

              <div>
                <div>
                  <pie
                    v-if="competencesSco[sco.name].datas.length > 0"
                    id-chart="romeCompetencesSpeSavoirFaire"
                    title="Savoir-faire"
                    :labels="competencesSco[sco.name].longLabels"
                    :values="[
                      competencesSco[sco.name].datas[0]['competences_spe'][
                        'savoir_faire'
                      ],
                      competencesSco[sco.name].datas[1]['competences_spe'][
                        'savoir_faire'
                      ],
                    ]"
                    :colors="competencesSco[sco.name].colors"
                    position-legend="bottom"
                    height="400"
                  />
                </div>
                <div
                  class="mt-5 w-full text-center flex justify-center"
                  v-if="
                    $can(constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_COMPARE)
                  "
                >
                  <action-button
                    class="py-2"
                    border-color="transparent"
                    text-color="text-white"
                    bg-color="bg-pink-600"
                    libelle="Comparer"
                    :is-disabled="cantCompare(sco.name)"
                    :enable-action="canCompare(sco.name)"
                    disabled-tooltip="Pour profiter de cette fonctionnalité, veuillez faire une deuxième évaluation pour les comparer."
                    @clickAction="
                      displayCompareCarto(
                        'compproRome/' +
                          sco.name +
                          '/competences_spe/savoir_faire'
                      )
                    "
                  />
                </div>
              </div>
              <div>
                <div>
                  <pie
                    v-if="competencesSco[sco.name].datas.length > 0"
                    id-chart="romeCompetencesSpeSavoirs"
                    title="Savoirs"
                    :labels="competencesSco[sco.name].longLabels"
                    :values="[
                      competencesSco[sco.name].datas[0]['competences_spe'][
                        'savoirs'
                      ],
                      competencesSco[sco.name].datas[1]['competences_spe'][
                        'savoirs'
                      ],
                    ]"
                    :colors="competencesSco[sco.name].colors"
                    position-legend="bottom"
                    height="400"
                  />
                </div>
                <div
                  class="mt-5 w-full text-center flex justify-center"
                  v-if="
                    $can(constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_COMPARE)
                  "
                >
                  <action-button
                    class="py-2"
                    border-color="transparent"
                    text-color="text-white"
                    bg-color="bg-pink-600"
                    libelle="Comparer"
                    :is-disabled="cantCompare(sco.name)"
                    :enable-action="canCompare(sco.name)"
                    disabled-tooltip="Pour profiter de cette fonctionnalité, veuillez faire une deuxième évaluation pour les comparer."
                    @clickAction="
                      displayCompareCarto(
                        'compproRome/' + sco.name + '/competences_spe/savoirs'
                      )
                    "
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- Case Display last evaluation in history -->
          <div
            v-else-if="
              historyCompetencesSco[sco.name] && selectedPoste == sco.name
            "
          >
            <div v-if="typeReferentiel === 'ref_formation'">
              <div
                v-for="(mod, indexModule) in historyCompetencesSco[sco.name][
                  historyCompetencesSco[sco.name].length - 1
                ][1]"
                :key="indexModule"
                class="mb-15"
              >
                <div v-if="!['name_job', 'labels'].includes(indexModule)">
                  <h5>{{ indexModule }}</h5>
                  <div class="xl:grid xl:grid-cols-2 xl:gap-x-5">
                    <div class="xl:col-span-1">
                      <bar
                        v-if="
                          Object.keys((mod || {}).module_competences || {})
                            .length > 0
                        "
                        :id-chart="
                          'compscoAutoToday' + indexModule + 'competences'
                        "
                        title="Compétences"
                        orientation="vertical"
                        thickness="10"
                        height="400"
                        width="400"
                        :stacked="false"
                        :labels="
                          historyCompetencesSco[sco.name][
                            historyCompetencesSco[sco.name].length - 1
                          ][1].labels
                        "
                        :values="mod.module_competences"
                        :display-legend="true"
                      />
                    </div>
                    <div class="xl:col-span-1">
                      <bar
                        v-if="
                          Object.keys(
                            (mod || {}).module_competences_transversales || {}
                          ).length > 0
                        "
                        :id-chart="
                          'compscoAutoToday' +
                          indexModule +
                          'competences_transversales'
                        "
                        title="Compétences transversales"
                        orientation="vertical"
                        thickness="10"
                        height="400"
                        width="400"
                        :stacked="false"
                        :labels="
                          historyCompetencesSco[sco.name][
                            historyCompetencesSco[sco.name].length - 1
                          ][1].labels
                        "
                        :values="mod.module_competences_transversales"
                        :display-legend="true"
                      />
                    </div>
                  </div>
                  <div
                    class="mt-8 w-full text-center flex justify-center"
                    v-if="
                      $can(
                        constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_COMPARE
                      )
                    "
                  >
                    <action-button
                      class="py-2"
                      border-color="transparent"
                      text-color="text-white"
                      bg-color="bg-pink-600"
                      libelle="Comparer"
                      :is-disabled="cantCompare(sco.name)"
                      :enable-action="canCompare(sco.name)"
                      @clickAction="
                        displayCompareCarto(
                          'compsco/' + sco.name + '/' + indexModule
                        )
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
            <div v-if="typeReferentiel === 'ROME'">
              <h3>Compétences de base</h3>
              <div>
                <div>
                  <pie
                    v-if="
                      historyCompetencesSco[sco.name][
                        historyCompetencesSco[sco.name].length - 1
                      ][1].datas.length > 0
                    "
                    id-chart="romeCompetencesBasesSavoirFaire"
                    title="Savoir-faire"
                    :labels="
                      historyCompetencesSco[sco.name][
                        historyCompetencesSco[sco.name].length - 1
                      ][1].longLabels
                    "
                    :values="[
                      historyCompetencesSco[sco.name][
                        historyCompetencesSco[sco.name].length - 1
                      ][1].datas[0]['competences_bases']['savoir_faire'],
                      historyCompetencesSco[sco.name][
                        historyCompetencesSco[sco.name].length - 1
                      ][1].datas[1]['competences_bases']['savoir_faire'],
                    ]"
                    :colors="
                      historyCompetencesSco[sco.name][
                        historyCompetencesSco[sco.name].length - 1
                      ][1].colors
                    "
                    position-legend="bottom"
                    height="400"
                  />
                </div>
                <div
                  class="mt-5 w-full text-center flex justify-center"
                  v-if="
                    $can(constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_COMPARE)
                  "
                >
                  <action-button
                    class="py-2"
                    border-color="transparent"
                    text-color="text-white"
                    bg-color="bg-pink-600"
                    libelle="Comparer"
                    :is-disabled="cantCompare(sco.name)"
                    :enable-action="canCompare(sco.name)"
                    disabled-tooltip="Pour profiter de cette fonctionnalité, veuillez faire une deuxième évaluation pour les comparer."
                    @clickAction="
                      displayCompareCarto(
                        'compproRome/' +
                          sco.name +
                          '/competences_bases/savoir_faire'
                      )
                    "
                  />
                </div>
              </div>
              <div>
                <div>
                  <pie
                    v-if="
                      historyCompetencesSco[sco.name][
                        historyCompetencesSco[sco.name].length - 1
                      ][1].datas.length > 0
                    "
                    id-chart="romeCompetencesBasesSavoirs"
                    title="Savoirs"
                    :labels="
                      historyCompetencesSco[sco.name][
                        historyCompetencesSco[sco.name].length - 1
                      ][1].longLabels
                    "
                    :values="[
                      historyCompetencesSco[sco.name][
                        historyCompetencesSco[sco.name].length - 1
                      ][1].datas[0]['competences_bases']['savoirs'],
                      historyCompetencesSco[sco.name][
                        historyCompetencesSco[sco.name].length - 1
                      ][1].datas[1]['competences_bases']['savoirs'],
                    ]"
                    :colors="
                      historyCompetencesSco[sco.name][
                        historyCompetencesSco[sco.name].length - 1
                      ][1].colors
                    "
                    position-legend="bottom"
                    height="400"
                  />
                </div>
                <div
                  class="mt-5 w-full text-center flex justify-center"
                  v-if="
                    $can(constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_COMPARE)
                  "
                >
                  <action-button
                    class="py-2"
                    border-color="transparent"
                    text-color="text-white"
                    bg-color="bg-pink-600"
                    libelle="Comparer"
                    :is-disabled="cantCompare(sco.name)"
                    :enable-action="canCompare(sco.name)"
                    disabled-tooltip="Pour profiter de cette fonctionnalité, veuillez faire une deuxième évaluation pour les comparer."
                    @clickAction="
                      displayCompareCarto(
                        'compproRome/' + sco.name + '/competences_bases/savoirs'
                      )
                    "
                  />
                </div>
              </div>

              <h3 class="mt-15">Compétences spécifiques</h3>

              <div>
                <div>
                  <pie
                    v-if="
                      historyCompetencesSco[sco.name][
                        historyCompetencesSco[sco.name].length - 1
                      ][1].datas.length > 0
                    "
                    id-chart="romeCompetencesSpeSavoirFaire"
                    title="Savoir-faire"
                    :labels="
                      historyCompetencesSco[sco.name][
                        historyCompetencesSco[sco.name].length - 1
                      ][1].longLabels
                    "
                    :values="[
                      historyCompetencesSco[sco.name][
                        historyCompetencesSco[sco.name].length - 1
                      ][1].datas[0]['competences_spe']['savoir_faire'],
                      historyCompetencesSco[sco.name][
                        historyCompetencesSco[sco.name].length - 1
                      ][1].datas[1]['competences_spe']['savoir_faire'],
                    ]"
                    :colors="
                      historyCompetencesSco[sco.name][
                        historyCompetencesSco[sco.name].length - 1
                      ][1].colors
                    "
                    position-legend="bottom"
                    height="400"
                  />
                </div>
                <div
                  class="mt-5 w-full text-center flex justify-center"
                  v-if="
                    $can(constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_COMPARE)
                  "
                >
                  <action-button
                    class="py-2"
                    border-color="transparent"
                    text-color="text-white"
                    bg-color="bg-pink-600"
                    libelle="Comparer"
                    :is-disabled="cantCompare(sco.name)"
                    :enable-action="canCompare(sco.name)"
                    disabled-tooltip="Pour profiter de cette fonctionnalité, veuillez faire une deuxième évaluation pour les comparer."
                    @clickAction="
                      displayCompareCarto(
                        'compproRome/' +
                          sco.name +
                          '/competences_spe/savoir_faire'
                      )
                    "
                  />
                </div>
              </div>
              <div>
                <div>
                  <pie
                    v-if="
                      historyCompetencesSco[sco.name][
                        historyCompetencesSco[sco.name].length - 1
                      ][1].datas.length > 0
                    "
                    id-chart="romeCompetencesSpeSavoirs"
                    title="Savoirs"
                    :labels="
                      historyCompetencesSco[sco.name][
                        historyCompetencesSco[sco.name].length - 1
                      ][1].longLabels
                    "
                    :values="[
                      historyCompetencesSco[sco.name][
                        historyCompetencesSco[sco.name].length - 1
                      ][1].datas[0]['competences_spe']['savoirs'],
                      historyCompetencesSco[sco.name][
                        historyCompetencesSco[sco.name].length - 1
                      ][1].datas[1]['competences_spe']['savoirs'],
                    ]"
                    :colors="
                      historyCompetencesSco[sco.name][
                        historyCompetencesSco[sco.name].length - 1
                      ][1].colors
                    "
                    position-legend="bottom"
                    height="400"
                  />
                </div>
                <div
                  class="mt-5 w-full text-center flex justify-center"
                  v-if="
                    $can(constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_COMPARE)
                  "
                >
                  <action-button
                    class="py-2"
                    border-color="transparent"
                    text-color="text-white"
                    bg-color="bg-pink-600"
                    libelle="Comparer"
                    :is-disabled="cantCompare(sco.name)"
                    :enable-action="canCompare(sco.name)"
                    disabled-tooltip="Pour profiter de cette fonctionnalité, veuillez faire une deuxième évaluation pour les comparer."
                    @clickAction="
                      displayCompareCarto(
                        'compproRome/' + sco.name + '/competences_spe/savoirs'
                      )
                    "
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="flex flex-col justify-center items-center w-full">
      <h6 class="text-pink-600 w-full mb-8">Aucune donnée</h6>
      <div class="text-indigo-600 text-center text-base mb-8">
        {{ infosPass.name }} n'a pas d'évaluation de compétences
        professionnelles
      </div>
      <div>
        <illustration name="no_result" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Icon from '../../../components/Icon';
import ActionButton from '../../../components/ActionButton';
import Radar from '../../../components/Charts/Radar';
import Pie from '../../../components/Charts/Pie';
import Bar from '../../../components/Charts/Bar';
import Popup from '../../../components/Popup';
import Illustration from '../../../components/Illustration';
import PopupCompareCarto from '../../../components/Cartographies/PopupCompareCarto';
import Constants from '../../../constants';

export default {
  components: {
    Icon,
    ActionButton,
    Radar,
    Popup,
    Illustration,
    Pie,
    Bar,
    PopupCompareCarto,
    Constants,
  },

  name: 'Compsco',

  data() {
    return {
      constants: Constants,
      colors: {
        type: 'normal',
        beneficiary: '#21B8C8',
        referent: '#FF1C80',
        true: '#21B8C85A',
        false: '#919AA65A',
      },
      compareCarto: false,
      cartoToCompare: '',
      historyToDisplay: -1,
      toReload: true, //use to hide and show cartography and check changes
      listCompetencesSco: [],
      showList: false,
      selectedPoste: Constants.PAGE_NEOPASS_FORM_FORMATION_1,
    };
  },

  created() {
    this.infosPage.pages.forEach((page) => {
      this.listCompetencesSco.push({ id: page.id, name: page.name });
    });
  },

  methods: {
    /**
     * display popup to compare a cartography
     * @param String typeCarto
     */
    displayCompareCarto(typeCarto) {
      this.compareCarto = true;
      this.cartoToCompare = typeCarto;
    },

    /**
     * Close popup to compare cartography
     */
    closeCompare() {
      this.compareCarto = false;
      this.cartoToCompare = '';
      this.historyToDisplay = -1;
    },

    /**
     * Change the history cartography to compare
     * @param Number index
     */
    changeCompare(index) {
      setTimeout(() => {
        this.historyToDisplay = -1;
      }, 300);
      setTimeout(() => {
        this.historyToDisplay = index;
      }, 300);
    },

    /**
     * /!\ Method not used for the moment
     * User can choose the cartography colors between old (passeport compétences) or new (neopass) colors
     * @param String n
     */
    switchColor(n) {
      switch (n) {
        case 'normal':
          this.colors.beneficiary = '#21B8C8';
          this.colors.referent = '#FF1C80';
          break;
        case 'old':
          this.colors.beneficiary = '#31AFDE';
          this.colors.referent = '#94AC49';
          break;
        default:
          this.colors.beneficiary = '#21B8C8';
          this.colors.referent = '#FF1C80';
          break;
      }
      this.colors.type = n;
      setTimeout(() => {
        this.toReload = false;
      }, 300);
      setTimeout(() => {
        this.toReload = true;
      }, 300);
    },

    /**
     * Display drop down to choose the poste
     */
    displayFieldList() {
      this.showList = !this.showList;
    },

    canCompare(page) {
      //TRUE if there are 2 evals in history
      //TRUE if there is 1 eval in history and 1 current eval
      //FALSE otherwise
      const evalCount = this.historyCompetencesSco?.[page]?.length ?? 0;
      const hasCurrent = Object.values(this.competencesSco?.[page] ?? {}).length > 0;
      return evalCount >= 2 || (evalCount > 0 && hasCurrent);
    },

    cantCompare(page) {
      return !this.canCompare(page);
    },
  },
  computed: {
    ...mapGetters({
      infosPass: 'cartographiesIndividuelles/infosPass',
      neopassDatas: 'cartographiesIndividuelles/neopassDatas',
      listEvaluations: 'cartographiesIndividuelles/listEvaluations',
      infosPage: 'cartographiesIndividuelles/infosPage',
    }),

    competencesSco: function () {
      return (this.neopassDatas || {})['compsco'] || {};
    },

    historyCompetencesSco: function () {
      return (this.listEvaluations || {})['compsco'] || {};
    },

    /**
     * Determine the template type between Job_Desc, Ref_formation or ROME
     */
    typeReferentiel: function () {
      if (this.competencesSco[this.selectedPoste]) {
        return this.competencesSco[this.selectedPoste].type
          ? this.competencesSco[this.selectedPoste].type
          : 'ref_formation';
      } else if (this.historyCompetencesSco[this.selectedPoste]) {
        return this.historyCompetencesSco[this.selectedPoste][
          this.historyCompetencesSco[this.selectedPoste].length - 1
        ][1].type
          ? this.historyCompetencesSco[this.selectedPoste][
              this.historyCompetencesSco[this.selectedPoste].length - 1
            ][1].type
          : 'ref_formation';
      }
    },

    /**
     * Determine the selected poste
     */
    currentPoste: function () {
      let numero = this.selectedPoste.split('f')[1];

      let jobName = '';

      if (this.competencesSco[this.selectedPoste]) {
        jobName =
          this.typeReferentiel === 'ROME'
            ? this.competencesSco[this.selectedPoste].title
            : this.competencesSco[this.selectedPoste].name_job;
      } else if (this.historyCompetencesSco[this.selectedPoste]) {
        jobName =
          this.typeReferentiel === 'ROME'
            ? this.historyCompetencesSco[this.selectedPoste][
                this.historyCompetencesSco[this.selectedPoste].length - 1
              ][1].title
            : this.historyCompetencesSco[this.selectedPoste][
                this.historyCompetencesSco[this.selectedPoste].length - 1
              ][1].name_job;
      }
      return 'Formation ' + numero + ' : ' + jobName;
    },
  },
};
</script>
